import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  const date = new Date(Date.now());
  let year = date.getFullYear();

  const [lang, setLang] = useState("En");
  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);
  return (
    <div class="footer-section section" style={{ backgroundColor: "#242424" }}>
      <div>
        <div class="container">
          <div class="footer-widget-wrap">
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <div class="footer-widget widget-about">
                  <a class="footer-logo" href="index.html">
                    <img
                      src={require("../../Assets/logo.png")}
                      alt="Logo"
                      width="200px"
                    />
                  </a>
                  <div class="widget-info">
                    <ul>
                      <li class="">
                        71 -75 Shelton Street, Covent Garden, London, WC2H 9JQ,
                        Great Britain{" "}
                      </li>
                      <li>info@goldbarint.com</li>
                    </ul>
                  </div>
                  <div class="footer-social">
                    <ul class="social">
                      <li>
                        <a href="#">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6">
                <div class="footer-widget">
                  <h4 class="footer-widget-title">
                    {lang === "Fr" ? `LIENS UTILES` : `Useful Links`}
                  </h4>
                  <div class="widget-link">
                    <ul class="link">
                      <li>
                        <Link to="/procedures">
                          {lang === "Fr" ? `Procédures` : `Procedures`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us">
                          {lang === "Fr"
                            ? `À propos de l’entreprise`
                            : `About Company`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/customers">
                          {lang === "Fr" ? `Clientèle` : `Customers`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact-us">
                          {lang === "Fr" ? `Contactez-nous` : `Contact Us`}{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-sm-6">
                <div class="footer-widget">
                  <h4 class="footer-widget-title">
                    {lang === "Fr" ? `NOS SERVICES` : `Our Services`}
                  </h4>
                  <div class="widget-link">
                    <ul class="link">
                      <li>
                        <Link to="/products-services">
                          {lang === "Fr" ? `Produit En Or` : `Gold Product`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/products-services">
                          {lang === "Fr" ? `Quantités d’or` : `Gold Quantities`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/products-services">
                          {lang === "Fr" ? `Prix de l’or` : `Gold Pricing`}
                        </Link>
                      </li>
                      <li>
                        <Link to="/products-services">
                          {lang === "Fr"
                            ? `Livraison de
produits/Logistique`
                            : `Product Delivery/Logistics`}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-copyright" style={{ background: "#14151e" }}>
          <div class="container">
            <div class="copyright-text text-center">
              <p>
                ©{" "}
                {lang === "Fr"
                  ? `Copyrights ${year} Gold Bar Tous droits réservés.`
                  : `Copyrights ${year} Gold Bar All rights reserved.`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
